export default __webpack_public_path__ + "static/media/IMG_20210706_175755.4a2a0e36.png";